import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const options = {
      threshold: 0.01 
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const impressionUrl = entry.target.dataset.impression
          if (impressionUrl) {
            const adsList = Array.from(document.querySelectorAll('.card-promo'))

            const url = new URL(impressionUrl)
            url.searchParams.append('position', adsList.indexOf(entry.target))
            url.searchParams.append('scroll', 0)

            fetch(url, {
              method: 'GET',
              mode: 'no-cors',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(() => {
                const timestamp = new Date().toISOString()
                console.log('Impression sent', entry.target.dataset.creatorUsername, 'at', timestamp)
              observer.unobserve(entry.target)
            })
            .catch(error => console.error('Error:', error))
          }
        }
      })
    }, options)

    observer.observe(this.element)
  }
}
